import { BoomerangVideoBg } from './BoomerangVideoBg.js';
import { CompanySection } from './CompanySection.js';
import { Footer } from './Footer.js';
import { Hero } from './Hero.js';
import { Navbar } from './Navbar.js';
import { PricingSection } from './PricingSection.js';
import { ProductSection } from './ProductSection.js';
import { SolutionsSection } from './SolutionsSection.js';

export function Landing() {
  return (
    <div className="relative min-h-screen bg-paper overflow-x-hidden">
      {/*
        One backdrop for the whole page, pinned to the viewport: the boomerang
        loop is captured once and keeps playing behind every section as the
        content scrolls over it. Sections carry their own frosted plates so the
        type stays readable against the footage.
      */}
      <BoomerangVideoBg position="fixed" />

      <Navbar />
      <main className="relative z-10">
        <Hero />
        <ProductSection />
        <SolutionsSection />
        <PricingSection />
        <CompanySection />
      </main>
      <Footer />
    </div>
  );
}

export default Landing;
